export const MONTHLY_REVIEWS_TABS = {
  keys: {
    DETAILS: 1,
    ACCOUNT_TITLES: 2
  },
  objects: {
    DETAILS: { tabName: "ریز اطلاعات", id: 1 },
    ACCOUNT_TITLES: {
      tabName: "سرفصل‌حساب",
      id: 2
    }
  }
};

export const PETTY_CASHIER_SUMMARY_TRANSACTIONS_TABS = {
  keys: {
    DETAILS: 1,
    ACCOUNT_TITLES: 2
  },
  objects: {
    DETAILS: { tabName: "پرداخت‌ها و دریافت‌ها", id: 1 },
    ACCOUNT_TITLES: {
      tabName: "سرفصل‌حساب",
      id: 2
    }
  }
};
